export default __webpack_public_path__ + "static/media/1510.5ede64af.png";